import React from 'react';
import { passwordRules } from '../../utils/validatePassword';

// Live checklist showing which password rules the current value satisfies.
export default function PasswordRequirements({ password }) {
  return (
    <ul
      aria-label="Password requirements"
      style={{ listStyle: 'none', padding: 0, margin: '0 0 0.75rem', fontSize: '0.85rem' }}
    >
      {passwordRules.map((rule) => {
        const met = rule.test(password || '');
        return (
          <li key={rule.label} style={{ color: met ? '#2e7d32' : '#757575', lineHeight: 1.7 }}>
            <span aria-hidden="true" style={{ display: 'inline-block', width: '1.2em' }}>
              {met ? '\u2713' : '\u2022'}
            </span>
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
}
